import * as yup from 'yup';

function name(formatMessage) {
  return yup
    .string()
    .required(
      formatMessage({
        id: 'CREATEFORM_NAME_FIELD_IS_REQUIRED',
        defaultMessage: 'Name is required',
      }),
    )
    .max(
      200,
      formatMessage({
        id: 'CREATEFORM_NAME_FIELD_MAX_CHARS_200',
        defaultMessage: 'Name should be less than 200 chars',
      }),
    );
}

function conditions(formatMessage) {
  return yup.string().required(
    formatMessage({
      id: 'CREATEFORM_CONDITIONS_FIELD_IS_REQUIRED',
      defaultMessage: 'Conditions is required',
    }),
  );
}

function outcome(formatMessage) {
  return yup.string().required(
    formatMessage({
      id: 'CREATEFORM_OUTCOME_FIELD_IS_REQUIRED',
      defaultMessage: 'Outcome is required',
    }),
  );
}

function isActive(formatMessage) {
  return yup.string().required(
    formatMessage({
      id: 'CREATEFORM_ISACTIVE_FIELD_IS_REQUIRED',
      defaultMessage: 'Is Active is required',
    }),
  );
}

const validationSchema = formatMessage =>
  yup
    .object({
      name: name(formatMessage),
      conditions: conditions(formatMessage),
      outcome: outcome(formatMessage),
      isActive: isActive(formatMessage),
    })
    .required();

export default validationSchema;
